import { useEffect } from 'react'

export const useOffice = ({
  onReadyCallback,
  onMailboxItemChangedCallback,
  onItemBodyChangedCallback,
}: {
  onReadyCallback?: (info: {
    host: Office.HostType
    platform: Office.PlatformType
  }) => void
  onMailboxItemChangedCallback?: (data: any) => void
  onItemBodyChangedCallback?: (body: string) => void
}) => {
  const prepareBodyChangeCallback = () => {
    Office.onReady(() => {
      Office?.context?.mailbox?.item?.body?.getAsync('html', (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          const emailBody = result.value
          onItemBodyChangedCallback?.(emailBody)
        }
      })
    })
  }

  useEffect(() => {
    Office.onReady((info) => {
      if (info.host === Office.HostType.Outlook) {
        onReadyCallback?.(info)
        prepareBodyChangeCallback()
        Office.context.mailbox.addHandlerAsync(
          Office.EventType.ItemChanged,
          (data: any) => {
            onMailboxItemChangedCallback?.(data)
            prepareBodyChangeCallback()
          }
        )
      }
    })
  }, [])
}
